import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import Vue from 'vue';
import store from '@/store';

import { getAsync, patchAsync } from '@/rpcutil';

export interface CatalogOrderStatus {
    id: number,
    companyName: string,
    address: string,
    date: Date,
    processed: number,
}

export interface CatalogOrderDetail extends CatalogOrderStatus {
    id: number,
    email: string,
    companyName: string,
    staffName: string,
    tel: string,
    address: string,
    date: Date,
    agency: number,
    processed: number,
}

export type CatalogOrderDetailStore = {
    [key: number]: CatalogOrderDetail,
}

function objectizeCatalogOrderDetail(val: CatalogOrderDetail) {
    const val_any: any = val;
    val.date = new Date(val_any.date);

    return val;
}

@Module({ name: 'catalog_order', namespaced: true, dynamic: true, store: store })
class RegistrationStore extends VuexModule {
    details: CatalogOrderDetailStore = {};
    status: CatalogOrderStatus[] = [];
    detail_status_map: { [key: number]: number } = {};
    status_whole: boolean = false;
    unprocessedCount: number = -1;

    @Mutation
    UPDATE_DETAIL(val: CatalogOrderDetail) {
        if(this.details[val.id] !== undefined && !this.details[val.id].processed && val.processed)
            this.unprocessedCount--;
        Vue.set(this.details, val.id, val);
        Vue.set(this.status, this.detail_status_map[val.id], val);
    }

    @Mutation
    UPDATE_STATUS(val: CatalogOrderStatus[]) {
        for(let i = 0; i < val.length; i++) {
            Vue.set(this.status, i, val[i]);
            this.detail_status_map[val[i].id] = i;
        }
        for(let i = val.length; i < this.status.length; i++) {
            Vue.delete(this.status, i);
        }
        this.status_whole = true;
    }

    @Mutation
    UPDATE_UNPROCESSED_COUNT(val: number) {
        this.unprocessedCount = val;
    }

    @Action({ rawError: true })
    async updateStatus() {
        const details: CatalogOrderDetail[] = (await getAsync('/api/catalog_order')).data;

        // convert some objects
        for(const detail of details) {
            objectizeCatalogOrderDetail(detail)
            this.UPDATE_DETAIL(detail);
        }

        this.UPDATE_STATUS(details);
        this.updateUnprocessedCount();
    }

    @Action({ rawError: true })
    async updateDetail(id: number) {
        if(typeof(id) !== "number") id = parseInt(id);
        const detail: CatalogOrderDetail = (await getAsync('/api/catalog_order/' + id)).data;
        objectizeCatalogOrderDetail(detail);
        this.UPDATE_DETAIL(detail);
    }

    @Action({ rawError: true })
    async updateUnprocessedCount() {
        const res = (await getAsync('/api/catalog_order_count')).data;
        if(typeof res.value === 'number')
            this.UPDATE_UNPROCESSED_COUNT(res.value);
    }

    @Action({ rawError: true })
    async getStatusList(): Promise<CatalogOrderDetailStore> {
        if(!this.status_whole) {
            await this.updateStatus();
        }
        return this.details;
    }

    @Action({ rawError: true })
    async modifyDetail(detail: CatalogOrderDetail) {
        const prev = this.details[detail.id];
        if(!prev) return;

        // extract modification
        let mods: { [key: string]: any } = {};
        for(const key in detail) {
            if((prev as any)[key] !== (detail as any)[key])
                mods[key] = (detail as any)[key];
        }

        if(Object.keys(mods).length > 0) {
            // send
            const result = await patchAsync('/api/catalog_order/' + detail.id, mods);
            if(result.data.result == "ok") {
                // apply locally
                this.UPDATE_DETAIL(detail);
                return true;
            }
            else
                return false;
        }
    }
}

export default getModule(RegistrationStore);
